import { render, staticRenderFns } from "./DrowningForm.vue?vue&type=template&id=3ff994c9&scoped=true"
import script from "./DrowningForm.vue?vue&type=script&lang=js"
export * from "./DrowningForm.vue?vue&type=script&lang=js"
import style0 from "./DrowningForm.vue?vue&type=style&index=0&id=3ff994c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff994c9",
  null
  
)

export default component.exports